import Breadcrumb from 'components/Breadcrumb/Breadcrumb';
import Button from 'components/Button/Button';
import ContactUsArrow from 'components/Icons/ContactUsArrow';
import ContactUsCalander from 'components/Icons/ContactUsCalander';
import ContactUsChat from 'components/Icons/ContactUsChat';
import ContactUsEmail from 'components/Icons/ContactUsEmail';
import ContactUsFacebook from 'components/Icons/ContactUsFacebook';
import ContactUsInstagram from 'components/Icons/ContactUsInstagram';
import ContactUsLinkedin from 'components/Icons/ContactUsLinkedin';
import ContactUsPhone from 'components/Icons/ContactUsPhone';
import ContactUsStore from 'components/Icons/ContactUsStore';
import ContactUsUsers from 'components/Icons/ContactUsUsers';
import ContactUsX from 'components/Icons/ContactUsX';
import { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import FAQ from 'components/ContactUs/Faq';
import notionStoreDataService from 'services/notion.stores.service';
import { StoreCountry } from 'constants/store.dataType';
import { useRouter } from 'next/router';
import ContactUsDone from 'components/Icons/ContactUsDone';
import Spinner from 'components/Spinner/Spinner';
import cx from 'classnames';
import Head from 'next/head';
import { wcApiDataService } from 'functions/wcApi';
import { getSeoMetaTags } from 'utils/common.utils';
import { SeoMetaTags } from 'constants/dataTypes';
import GlobalSeoMetaTags from 'components/GlobalSeoMetaTags/GlobalSeoMetaTags';

const PhoneNumberInputController = dynamic(
    () => import('components/PhoneNumber/ContactUsPhoneNumberInput')
);
type Inputs = {
    name: string;
    email: string;
    phone: string;
    message: string;
};

const regions: any = {
    "au": {
        "email": "hello@dresden.vision",
        "phone": "(02) 5300 3003",
        "chat": "Zendesk Chat for AU",
        "workingHours": "09:00 - 17:30 AEDT",
        "socialMedia": [
            { "platform": "Instagram", "url": "https://www.instagram.com/dresdenvision/", "description": "Instagram (@dresdenvision)" },
            { "platform": "Facebook", "url": "https://www.facebook.com/dresdenvision", "description": "Facebook" },
            { "platform": "X", "url": "https://twitter.com/dresdenvision/", "description": "Dresden Vision (@dresdenvision) on X" },
            { "platform": "Linkedin", "url": "https://www.linkedin.com/company/dresdenvision/", "description": "Linkedin" }
        ],
        "careerUrl": "https://dresden.vision/au/career",
        "mediaEmail": "bonnie@au.dresden.vision"
    },
    "nz": {
        "email": "hello@dresden.vision",
        "phone": "0800 447 111",
        "chat": "Zendesk Chat for NZ",
        "workingHours": "11:00 - 19:00  NZST",
        "socialMedia": [
            { "platform": "Instagram", "url": "https://www.instagram.com/dresdenvision/", "description": "Instagram (@dresdenvision)" },
            { "platform": "Facebook", "url": "https://www.facebook.com/dresdenvision", "description": "Facebook" },
            { "platform": "X", "url": "https://twitter.com/dresdenvision/", "description": "Dresden Vision (@dresdenvision) on X" },
            { "platform": "Linkedin", "url": "https://www.linkedin.com/company/dresdenvision/", "description": "Linkedin" }
        ],
        "mediaEmail": "bonnie@au.dresden.vision"
    },
    "ca": {
        "email": "hello@ca.dresden.vision",
        "phone": "(647) 424 4288",
        "chat": "Zendesk Chat for CA",
        "workingHours": "09:00 - 18:00 EST. Saturday 11:00 - 18:00 EST.",
        "socialMedia": [
            { "platform": "Instagram", "url": "https://www.instagram.com/dresdenvisionca/", "description": "Instagram (@dresdenvision)" },
            { "platform": "Facebook", "url": "https://www.facebook.com/dresdenvisioncanada", "description": "Facebook" },
            { "platform": "X", "url": "https://twitter.com/dresdenvision/", "description": "Dresden Vision (@dresdenvision) on X" },
            { "platform": "Linkedin", "url": "https://www.linkedin.com/company/dresdenvision/", "description": "Linkedin" }
        ],
        "mediaEmail": "mike@ca.dresden.vision"
    },
    "international": {
        "email": "hello@dresden.vision",
        "phone": "(02) 5300 3003",
        "chat": "Zendesk Chat for AU",
        "workingHours": "09:00 - 17:30 AEDT",
        "socialMedia": [
            { "platform": "Instagram", "url": "https://www.instagram.com/dresdenvision/", "description": "Instagram (@dresdenvision)" },
            { "platform": "Facebook", "url": "https://www.facebook.com/dresdenvision", "description": "Facebook" },
            { "platform": "X", "url": "https://twitter.com/dresdenvision/", "description": "Dresden Vision (@dresdenvision) on X" },
            { "platform": "Linkedin", "url": "https://www.linkedin.com/company/dresdenvision/", "description": "Linkedin" }
        ],
        "mediaEmail": "bonnie@au.dresden.vision"
    }
}


export default function ContactUs({
    stores,
    faq,
    seoMetaTags
}: {
    stores: any;
    faq: any;
    seoMetaTags: SeoMetaTags;
}) {
    const router = useRouter();
    const [region, setRegion] = useState<'au' | 'nz' | 'ca' | 'international'>(router.locale as any);
    const currentRegion = regions[region];
    const [messageSent, setMessageSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<any>(null);

    useEffect(() => {
        setRegion(router.locale as any);
    }, [router.locale]);

    const handleChange = (e: Inputs) => {
        setLoading(true);
        const body = {
            nameSurname: e.name,
            email: e.email,
            phone: e.phone,
            message: e.message,
            region: router.locale
        };
        const options = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
            },
        };

        fetch('/api/contact-us', options)
            .then((res) => res.json())
            .then((res) => {
                setLoading(false);
                if (res.val.result) {
                    setMessageSent(true);
                } else {
                    setErrorMessage('Something went wrong, please try again later')
                }
            }).catch((err) => {
                console.log(err);
                setLoading(false);
                setErrorMessage('Something went wrong, please try again later')
            });
    };

    const breadCrumbData = [
        {
            id: 1,
            href: '',
            text: 'Dresden Vision'
        },
        {
            id: 2,
            href: 'contact-us',
            text: 'Contact Us'
        },
    ];

    const [phoneUpdateIdx, setPhoneUpdateIdx] = useState(0);
    const { register, handleSubmit, control, setValue, getValues, clearErrors, formState: { errors }, reset } = useForm<Inputs>();
    const getSocialMedia = (platform: string) => {
        const platformData = currentRegion.socialMedia.find((social: any) => social.platform === platform);
        if (platformData) {
            return platformData.url;
        }
    }


    return (
        <div className='container max-w-[1224px] mx-auto p-4'>
            <Head>
                <title>Contact Us | Dresden Vision</title>
                <meta
                    name="twitter:title"
                    content={`Contact Us | Dresden Vision`}
                />
                <meta
                    name="og:title"
                    content={`Contact Us | Dresden Vision`}
                />
                <meta
                    name="description"
                    content={`Get in touch with Dresden Vision for any inquiries or support. We're here to help you with your optical needs. Contact us via phone, email, or our online form.`}
                />
                <meta
                    property="og:description"
                    content={`Get in touch with Dresden Vision for any inquiries or support. We're here to help you with your optical needs. Contact us via phone, email, or our online form.`}
                />
                <meta
                    name="twitter:description"
                    content={`Get in touch with Dresden Vision for any inquiries or support. We're here to help you with your optical needs. Contact us via phone, email, or our online form.`}
                />
            </Head>

            <Breadcrumb data={breadCrumbData} />
            <div className='flex relative mt-[30px] flex-col'>
                <div className="bg-[#E7E8FF] md:px-[50px] md:py-[40px] p-[20px] rounded-lg  w-full">
                    <h1 className="text-3xl md:text-5xl font-normal mb-4 text-[#2A2A2A]">
                        Get in Touch with Us
                    </h1>
                    <p className="text-base font-normal text-[#616161] mb-4 md:mb-8 md:leading-5 leading-none" dangerouslySetInnerHTML={{
                        __html: `
                        Whether you have questions, feedback, or just want to say hello, we're all ears. <br />
                        Drop us a line and let's start the conversation!
                       `
                    }}>
                    </p>
                    <div className="md:w-1/2 md:pr-8 mb-4 md:mb-0">
                        <div className='flex items-center aligns-center gap-[10px]'>
                            <div className='bg-white w-[48px] h-[48px] p-[12px] flex items-center aligns-center rounded-full	'>
                                <ContactUsEmail />
                            </div>
                            <p className='text-[#616161] text-[18px]'><a href={"mailto:" + currentRegion.email}>{currentRegion.email}</a></p>
                        </div>

                        <div className='flex items-center aligns-center gap-[10px] mt-[14px]'>
                            <div className='bg-white w-[48px] h-[48px] p-[12px] flex items-center aligns-center rounded-full	'>
                                <ContactUsPhone />
                            </div>
                            <p className='text-[#616161] text-[18px]'><a href={"tel:" + currentRegion.phone}>{currentRegion.phone}</a></p>
                        </div>

                        <div className='flex items-center aligns-center gap-[10px] mt-[14px] cursor-pointer' onClick={() => {
                            try {
                                if (window) {
                                    //@ts-ignore
                                    window.zE("messenger", "open")
                                }
                            } catch (e) {
                                console.log("zendesk not loaded")
                            }
                        }}>
                            <div className='bg-white w-[48px] h-[48px] p-[12px] flex items-center aligns-center rounded-full	'>
                                <ContactUsChat fill='black' />
                            </div>
                            <p className='text-[#616161] text-[18px]'>Online Chat</p>
                        </div>

                        <div className='mt-[30px] bg-[#FFFFB3] flex md:w-[420px] items-center aligns-center rounded-[12px] px-[14px] py-[16px]  md:px-[16px] md:py-[20px]'>
                            <div className='flex  items-center aligns-center gap-[12px]'>
                                <ContactUsCalander />
                                <p className='text-l text-center md:w-full w-[90px] leading-none'>Working Hours</p>
                            </div>
                            <div className='h-[40px] w-[1px] bg-[#CBCB83] md:ml-[40px] md:mr-[40px]  ml-[10px] mr-[10px]  '> </div>
                            {router.locale == 'ca' ? (
                                <div>
                                    <p className='md:text-sm text-xs font-semibold'>Monday - Friday</p>
                                    <p className='text-[#616161] md:text-sm text-xs'>09:00 - 18:00 EST. </p>
                                    <p className='md:text-sm text-xs font-semibold'>Saturday</p>
                                    <p className='text-[#616161] md:text-sm text-xs'>11:00 - 18:00 EST. </p>
                                </div>
                            ) : (
                                <div>
                                    <p className='md:text-sm text-xs font-semibold'>Monday - Saturday</p>
                                    <p className='text-[#616161] md:text-sm text-xs'>{currentRegion.workingHours}</p>
                                </div>
                            )}

                        </div>
                    </div>
                </div>

                <div className="md:w-[392px] mt-[30px] md:mt-[0px] bg-white h-auto shadow md:px-[40px] md:py-[30px] p-[20px] md:absolute right-[50px] top-[40px] rounded-[12px]">
                    {!messageSent && (
                        <div>
                            <div>
                                <h3 className='text-[24px]'>Drop Us a Line</h3>
                                <p className='text-[#959595] text-[14px]'>Send your thoughts, ideas, suggestions</p>
                            </div>

                            <div className='mt-[24px]'>
                                <form onSubmit={handleSubmit(handleChange)}>
                                    <div>
                                        <label className="font-medium text-[14px] " htmlFor="">Name Surname *</label>
                                        <input
                                            {...register('name', {
                                                required: true,
                                                minLength: 4
                                            })}
                                            className="lg:w-80 mt-[6px] lgx:w-full h-[46px] border border-brand-grey400 rounded-[6px] outline-[#243c5a]" style={{ textIndent: '8px' }} type="text" />

                                        {errors.name && errors.name.type === 'minLength' && (
                                            <p style={{ fontSize: 12, color: '#d83e3e' }}>
                                                Name must be at least 4 characters
                                            </p>
                                        )}

                                        {errors.name && errors.name.type === 'required' && (
                                            <p style={{ fontSize: 12, color: '#d83e3e' }}>
                                                Name is required
                                            </p>
                                        )}
                                    </div>

                                    <div className='mt-[18px]'>
                                        <label className="font-medium text-[14px] " htmlFor="">Email *</label>
                                        <input {...register('email', {
                                            required: true,
                                            pattern: {
                                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                message: 'Please enter a valid email'
                                            }
                                        })} className="lg:w-80 mt-[6px] lgx:w-full h-[46px] border border-brand-grey400 rounded-[6px] outline-[#243c5a]" style={{ textIndent: '8px' }} type="text" />

                                        {errors.email && (
                                            <p style={{ fontSize: 12, color: '#d83e3e' }}>
                                                {errors.email.message || 'Email is required'}
                                            </p>
                                        )}
                                    </div>

                                    <div className='mt-[18px]'>
                                        <label className="font-medium text-[14px] " htmlFor="">Mobile Number</label>
                                        <div className='mt-[6px]'>
                                            <PhoneNumberInputController
                                                key={phoneUpdateIdx}
                                                name="phone"
                                                control={control}
                                                required={false}
                                            />
                                            {errors.phone && (
                                                <p style={{ fontSize: 12, color: '#d83e3e' }}>
                                                    Phone number is not valid
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    <div className='mt-[18px]'>
                                        <label className={"font-medium text-[14px]"} htmlFor="">Your Message *</label>
                                        <input
                                            {...register('message', {
                                                required: true,
                                                minLength: 10
                                            })}
                                            className="lg:w-80 mt-[6px] lgx:w-full h-[46px] border border-brand-grey400 rounded-[6px] outline-[#243c5a]" style={{ textIndent: '8px' }} type="text" />

                                        {errors.message && errors.message.type === 'minLength' && (
                                            <p style={{ fontSize: 12, color: '#d83e3e' }}>
                                                Message must be at least 10 characters
                                            </p>
                                        )}

                                        {errors.message && errors.message.type === 'required' && (
                                            <p style={{ fontSize: 12, color: '#d83e3e' }}>
                                                Message is required
                                            </p>
                                        )}
                                    </div>

                                    <Button
                                        type="submit"
                                        className="text-center bg-brand-black50 mt-[18px] w-full justify-center"
                                        textClass="font-medium text-white text-sm flex items-center">
                                        {loading && (
                                            <div className='mr-2'>
                                                <Spinner fill='#fff' />
                                            </div>
                                        )}
                                        Send Message
                                    </Button>

                                    {errorMessage && (
                                        <p style={{ fontSize: 12, color: '#d83e3e' }}>
                                            {errorMessage}
                                        </p>
                                    )}
                                </form>
                            </div>
                        </div>
                    )}

                    {messageSent && (
                        <div className='flex items-center justify-center w-full h-full'>

                            <div className='flex items-center justify-center flex-col'>
                                <div>
                                    <ContactUsDone />
                                </div>

                                <div className='mt-[20px]'>
                                    <p className='text-xl text-center font-medium text-[#2A2A2A]'>Your message has been <br /> successfully sent.</p>
                                    <p className='text-sm text-[#959595] mt-[10px]'>We will be in touch with you shortly</p>
                                    <p className='text-[#00AEC7] text-sm mt-[20px] text-center cursor-pointer' onClick={() => {
                                        setMessageSent(false);
                                        reset();
                                    }}>Send a new message</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {(stores && router.locale !== 'international' && router.locale !== 'nz') && (
                <div className="mt-8 md:mt-[100px]">
                    <div className="flex items-center aligns-center gap-[10px]">
                        <ContactUsStore />
                        <p className='text-2xl text-[#2A2A2A]'> Our Stores in {
                            router.locale == 'au' ? 'Australia' : 'Canada'
                        }</p></div>
                    <div className="grid md:grid-cols-4 grid-cols-1 gap-4 mt-[20px]">
                        {stores.sort((a: any, b: any) => a.name.localeCompare(b.name)).map((store: any, index: any) => (
                            <div key={index}
                                onClick={() => {
                                    router.push(`/store/${store.slug}`);
                                }}
                                className='px-[24px] cursor-pointer py-[10px] flex items-center aligns-center gap-[6px] rounded-[12px]'
                                style={{ border: '1px solid var(--Grey---04, #CACACA)' }}>
                                <div className='flex-1'>
                                    <h3 className="text-lg md:text-lg font-medium text-[#2A2A2A] mb-[6px]">{store.name}</h3>
                                    <p className='text-[#959595] font-normal text-sm'>{store.address}</p>
                                </div>
                                <div>
                                    <ContactUsArrow />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )
            }

            <div className="mt-8 md:mt-[60px]">
                <div

                    className={cx(
                        'grid grid-cols-1 gap-4',
                        {
                            'md:grid-cols-3': router.locale == 'ca'
                        },
                        {
                            'md:grid-cols-2': router.locale !== 'ca'
                        },
                        {
                            'md:mt-[160px]': router.locale !== 'ca'
                        }
                    )}>
                    <div className='bg-[#F6F6F6] h-[185px] rounded-[12px] p-[30px]'>
                        <div>
                            <p className='text-2xl text-[#2A2A2A]'>Social Media</p>
                            <p className='text-[#959595] text-sm'>Find us on social media</p>
                        </div>

                        <div className='mt-[30px] flex flex-row gap-[14px]'>
                            <Link href={getSocialMedia('Facebook')} target='_blank'>
                                <div className='bg-white h-[48px] w-[48px] flex items-center justify-center	rounded-full'>
                                    <ContactUsFacebook />
                                </div>
                            </Link>
                            <Link href={getSocialMedia('X')} target='_blank'>
                                <div className='bg-white h-[48px] w-[48px] flex items-center justify-center	rounded-full'>
                                    <ContactUsX />
                                </div>
                            </Link>

                            <Link href={getSocialMedia('Instagram')} target='_blank'>
                                <div className='bg-white h-[48px] w-[48px] flex items-center justify-center	rounded-full'>
                                    <ContactUsInstagram />
                                </div>
                            </Link>

                            <Link href={getSocialMedia('Linkedin')} target='_blank' >
                                <div className='bg-white h-[48px] w-[48px] flex items-center justify-center	rounded-full'>
                                    <ContactUsLinkedin />
                                </div>
                            </Link>
                        </div>
                    </div>
                    {(router.locale == 'ca') && (
                        <div className='bg-[#F6F6F6] h-[185px] rounded-[12px] p-[30px]'>
                            <div>
                                <p className='text-2xl text-[#2A2A2A]'>Come Work With Us!</p>
                                <p className='text-[#959595] text-sm'>Join us on our mission to make glasses simple</p>
                            </div>

                            <div className='mt-[30px] flex flex-row gap-[14px]'>
                                <Link href="career">
                                    <div className='flex items-center justify-center gap-[10px] '>
                                        <div className='bg-white h-[48px] w-[48px] flex items-center justify-center	rounded-full'>
                                            <ContactUsUsers />
                                        </div>
                                        <p className='text-lg text-[#2A2A2A]'>Open positions</p>
                                    </div>
                                </Link>

                            </div>
                        </div>
                    )}

                    <div className='bg-[#F6F6F6] h-[185px] rounded-[12px] p-[30px]'>
                        <div>
                            <p className='text-2xl text-[#2A2A2A]'>Media Enquiries</p>
                            <p className='text-[#959595] text-sm'>Drop us a line for all media enquiries</p>
                        </div>

                        <div className='mt-[30px] flex flex-row gap-[14px]'>
                            <div className='flex items-center justify-center gap-[10px] '>
                                <div className='bg-white h-[48px] w-[48px] flex items-center justify-center	rounded-full'>
                                    <ContactUsEmail />
                                </div>
                                <p className='text-lg text-[#2A2A2A]'>{currentRegion.mediaEmail}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FAQ faq={faq} />
            <GlobalSeoMetaTags seoMetaTags={seoMetaTags} />
        </div >
    );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
    const stores: StoreCountry[] = await notionStoreDataService.getStores();
    const allstores: any = [];
    stores.map((countryData: any) => {
        countryData.states.map((stateData: any) => {
            stateData.stores.map((storeData: any) => {
                if (countryData.country.name == 'Australian' && locale == 'au') {
                    allstores.push(storeData);
                } else if (locale == 'ca' && countryData.country.name == 'Canadian') {
                    allstores.push(storeData);
                }
            });
        })
    });


    var faq: any = await wcApiDataService('post/faq', '', locale);

    const seoMetaTags = await getSeoMetaTags('/contact-us', locale);

    return {
        props: {
            stores: allstores, faq: faq, seoMetaTags

        }
    };
};

